import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Realtime pushes the important invalidations, so polling is mostly
      // unnecessary; the refetch on focus covers the case where the socket
      // dropped while the phone was asleep.
      staleTime: 30_000,
      gcTime: 30 * 60_000,
      refetchOnWindowFocus: true,
      refetchOnReconnect: true,
      retry: (failureCount, error) => {
        // Do not hammer the API when the device is simply offline.
        if (!navigator.onLine) return false;
        return failureCount < 2 && !isAuthError(error);
      },
    },
    mutations: {
      retry: 0,
    },
  },
});

function isAuthError(error: unknown): boolean {
  const status = (error as { status?: number } | null)?.status;
  return status === 401 || status === 403;
}

/** Query keys in one place so invalidation never goes stale. */
export const keys = {
  profiles: ["profiles"] as const,
  profile: (id: string) => ["profiles", id] as const,
  goals: ["goals"] as const,
  goalsByOwner: (ownerId: string) => ["goals", "owner", ownerId] as const,
  goal: (id: string) => ["goals", id] as const,
  stats: ["goal_stats"] as const,
  weekPeriods: ["goal_periods", "week"] as const,
  checkIns: ["check_ins"] as const,
  checkInsByGoal: (goalId: string) => ["check_ins", "goal", goalId] as const,
  feed: ["feed"] as const,
  likes: ["check_in_likes"] as const,
  comments: ["check_in_comments"] as const,
  recap: ["weekly_recap"] as const,
  pushSubscription: ["push_subscription"] as const,
  outbox: ["outbox"] as const,
};
